var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoiceCon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.0586C16.5228 21.0586 21 16.5814 21 11.0586C21 5.53575 16.5228 1.05859 11 1.05859C5.47715 1.05859 1 5.53575 1 11.0586C1 16.5814 5.47715 21.0586 11 21.0586Z",
    fill: "white",
    stroke: "#FF517E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6691 7.84766L9.2492 14.2676L6.33105 11.3494",
    stroke: "#CC1D4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoiceCon);
export default __webpack_public_path__ + "static/media/choice-con.80f0e8196e64e8ae12bb63fa59f6cc2f.svg";
export { ForwardRef as ReactComponent };